<template>
  <li :class="{'nav-item': true, opened: visible}">
    <a href="#" @click.prevent="collapse()" :aria-expanded="visible" class="nav-link">
      <i :class="`${icon} text-${color}`"></i>
      <span class="nav-link-text">{{ name }} <b :class="{ caret: true, opened: visible }"><i class="ti-angle-down"></i></b></span>
    </a>
    <b-collapse v-model="visible">
      <ul class="nav">
        <slot></slot>
      </ul>
    </b-collapse>
  </li>
</template>

<script>
  export default {
    name: 'SidebarDropdown',
    props: {
      name: {
        type: String,
      },
      icon: {
        type: String,
      },
      color: {
        type: String,
        default: 'default',
      },
    },
    data(){
      return {
        visible: false,
      }
    },
    methods: {
      collapse(){
        this.visible = !this.visible;
        if( this.visible ) {
          this.$emit('opened');
        }
      }
    }
  }
</script>

<style scoped>
  li.opened {
    background: #605d5d;
    padding-bottom: 10px;
  }
</style>
